import { Lightbulb } from 'lucide-react';

export function StudyTipWidget() {
  return (
    <div className="rounded-2xl bg-white dark:bg-[#1b1d34] border border-slate-200/80 dark:border-white/10 p-5 shadow-xs relative overflow-hidden flex flex-col gap-2">
      <div className="flex items-center gap-2 text-amber-500">
        <Lightbulb className="h-4.5 w-4.5" />
        <h4 className="text-base font-bold text-slate-900 dark:text-white tracking-tight">Study Tip</h4>
      </div>

      <p className="text-xs text-slate-600 dark:text-slate-300 font-medium leading-relaxed max-w-[210px] z-10 mt-1">
        Break your tasks into small parts and complete them one by one. You can do it! 💪
      </p>

      {/* Flat Vector Illustration of Books & Pen */}
      <div className="absolute right-3 bottom-2 w-20 h-20 pointer-events-none opacity-95">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          {/* Book Stack */}
          {/* Book 1 (Bottom Orange) */}
          <rect x="10" y="65" width="55" height="12" rx="3" fill="#ea580c" />
          <rect x="8" y="66" width="4" height="10" rx="2" fill="#fed7aa" />
          {/* Book 2 (Middle Blue) */}
          <rect x="15" y="52" width="50" height="12" rx="3" fill="#2563eb" />
          <rect x="13" y="53" width="4" height="10" rx="2" fill="#bfdbfe" />
          {/* Book 3 (Top Cyan) */}
          <rect x="20" y="40" width="45" height="11" rx="3" fill="#06b6d4" />
          <rect x="18" y="41" width="4" height="9" rx="2" fill="#cffafe" />
          {/* Pencil Cup */}
          <path d="M72 45 L86 45 L83 80 L75 80 Z" fill="#16a34a" />
          {/* Pencil / Pen */}
          <rect x="74" y="20" width="5" height="30" rx="2" fill="#f59e0b" transform="rotate(-12 74 20)" />
          <polygon points="73,15 76,20 71,20" fill="#fde68a" />
          <polygon points="73,15 74.5,17 72,17" fill="#1e293b" />
          {/* Ruler */}
          <rect x="81" y="25" width="4" height="25" rx="1" fill="#ec4899" transform="rotate(15 81 25)" />
        </svg>
      </div>
    </div>
  );
}
